// extracted by mini-css-extract-plugin
module.exports = {"heroContainer":"EventDetailsHero_heroContainer__cmfCu","breadcrumb":"EventDetailsHero_breadcrumb__DdFrN","title":"EventDetailsHero_title__JB_qs"};